module.exports = __webpack_public_path__ + "img/arrow-down-right-square.3808d103.svg";